import { Divider } from 'antd';
import styled from 'styled-components';

import { ReactComponent as DropDownIcon } from '../../assets/images/dropDownIcon.svg';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 1200px;
  max-height: 95vh;
  min-height: 85vh;
  padding: ${({ theme }): string => theme.spacers!.spacer06} 0 ${({ theme }): string => theme.spacers!.spacer05}
    ${({ theme }): string => theme.spacers!.spacer07};
  border-radius: 20px 0 0 20px;
  background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[0]};
  display: flex;
  flex-direction: column;
  overflow: auto;
  outline: none;

  & > div {
    padding-right: ${({ theme }): string => theme.spacers!.spacer06};
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer05};

  svg {
    cursor: pointer;
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer05};

  h3 {
    margin-bottom: ${({ theme }): string => theme.spacers!.spacer02};
  }
`;

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
`;

export const ModalMainContentWrapper = styled.div`
  flex: 1 1 100%;
  width: 100%;
`;

export const ModalButtonActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const BackIconContainer = styled.span`
  display: flex;
  width: 40px;
  margin-left: ${({ theme }): string => theme.spacers!.spacer04};
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer02};
`;
export const BackIcon = styled(DropDownIcon)`
  transform: rotate(90deg);
  height: 16px;
  cursor: pointer;
`;

export const TopDivider = styled(Divider)`
  margin-top: ${({ theme }): string => theme.spacers!.spacer02};
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer01};
`;

export const StyledTitle = styled.div`
  color: ${({ theme }): string => theme.admanColors!.gray.dark.bg3[0]};
  font-family: InspireTWDC;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;
